__turbopack_context__.v({
  "className": "noto_sans_mono_989540bc-module___VnrhG__className",
  "variable": "noto_sans_mono_989540bc-module___VnrhG__variable",
});
